const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:3002';

const config = {
  API_HOST,
};

export default config;
